import React from "react";

const TextLinkCell = ({ props }) => {
    let data = props.data;
    let id = props.data[0]; // unique id
    let colIndex = props.colIndex;
    let textValue = data[colIndex];
    let projectId = props?.projectid;
    let isQuiz = props?.isQuiz;
    let isUpdatedView = props?.isUpdatedView;

    const navigateToSitePage = (e) => {
        e.preventDefault();
        props.schema.handleLink({ id, projectId, isQuiz, isUpdatedView });
    };

    return <span
        role="button"
        onClick={navigateToSitePage}
        className={`indi-table-item-clickable ${id}`}>
        {textValue}
    </span>;
};

export default TextLinkCell;
